import '../assets/css/freeformatter-out.css';
import '../assets/css/learning-home.css';
import '../assets/css/528p2id4vvcvindizx35tcz0.css';
import '../assets/css/linkedin-main.scss';
import '../assets/css/message.css';
import '../assets/css/main.scss';
import '../assets/css/lmain.scss';
import '../assets/css/cmain.scss';


import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from 'react-tap-event-plugin';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import SplashPage from './homecomponents/pages/splash';
import SplashHomePage from './homecomponents/pages/splash-home';
import SplashHome2Page from './homecomponents/pages/splash-home2';
import ProjectPage from './homecomponents/pages/project';
import ForgotPage from './homecomponents/pages/forgot';
import SignInPage from './homecomponents/pages/signin';
import ProjectSignInPage from './homecomponents/pages/project-signin';
import SignUpPage from './homecomponents/pages/signup';
import SignUpPage1 from './homecomponents/pages/signup1';
import SignUpPage2 from './homecomponents/pages/signup2';
import ESignUpPage from './homecomponents/pages/esignup';
import EDemoPage from './homecomponents/pages/edemo';
import EDemo2Page from './homecomponents/pages/edemo2';
import EDemo3Page from './homecomponents/pages/edemo3';
import EDemo4Page from './homecomponents/pages/edemo4';
import EDemo5Page from './homecomponents/pages/edemo5';
import TermPage from './homecomponents/pages/terms';
import ProjectTermPage from './homecomponents/pages/project-terms';
import ProjectDetailPage from './homecomponents/pages/product-detail';
import PrivacyPage from './homecomponents/pages/privacy';
import AboutPage from './homecomponents/pages/about';
import AdvertisePage from './homecomponents/pages/advertise';
import MarketingPage from './homecomponents/pages/marketing';
import TalentPage from './homecomponents/pages/talent';
import PostPage from './homecomponents/pages/post';
import CareerPage from './homecomponents/pages/career';
import NewsPage from './homecomponents/pages/news';
import ExpertPage from './homecomponents/pages/expert';
import EWelcomePage from './homecomponents/pages/ewelcome';
import WelcomeCompanyPage from "./homecomponents/pages/company";
import ProjectPostPage from "./homecomponents/pages/project-post";
//import ProjectDetailPage from "./appcomponents/pages/career-product-detail";
import ExperientialChallengeDetailPublic  from "./appcomponents/pages/experiential-challenge-detail-public";
import InternshipPublic  from "./iappcomponents/pages/internship-public";
import PeerPublic  from "./appcomponents/pages/peer-public";
import store from './store';

import ReactGA from 'react-ga';

injectTapEventPlugin();

import {Redirect, Router, Route, IndexRoute, IndexLink, Link, useRouterHistory} from 'react-router';
import {createHistory} from 'history'
import PolicyPage from "./homecomponents/pages/policy";
import RecruitePage from "./homecomponents/pages/recruite";
import ProfilePage from "./appcomponents/pages/profilepulic";
import CompaniesPage from "./homecomponents/pages/companies";
import EnterprisePage from "./homecomponents/pages/enterprise";
import EnterpriseBrowsePage from "./homecomponents/pages/enterprise-browse";
import ServicesBrowsePage from "./homecomponents/pages/services-browse";
import ServicesBrowseTagPage from "./homecomponents/pages/services-browse-tag";
import StudentsPage from "./homecomponents/pages/students";
import EducatorsPage from "./homecomponents/pages/educators";
import ErrorPage from "./homecomponents/pages/error";
import CompanyDetailPage from "./homecomponents/pages/company-detail";
import UniversityProfilePage from "./homecomponents/pages/university-profile";
import ExperientialChallengeDetailPage from "./appcomponents/pages/experiential-challenge-detail";
import ProfileCoachPage from "./appcomponents/pages/profilepulic-coach";


const browserHistory = useRouterHistory(createHistory)({
    basename: '/',
    queryKey: false
})

class App extends React.Component {
    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.state = {open: false, message: ""};

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
    }

    handleClose() {
        this.setState({open: false, message: ""});
    };

    openDialog(message) {
        this.setState({open: true, message: message});
        //this.state.open = true;
    };

    render() {
        //console.log('windoe');
        const actions = [
            <FlatButton
                label="Discard"
                primary={true}
                onTouchTap={this.handleClose}
            />,
        ];
        const childrenWithProps = React.Children.map(this.props.children,
            (child) => React.cloneElement(child, {
                openDialog: this.openDialog
            })
        );
        return (
            <MuiThemeProvider>
                <div>
                    {childrenWithProps}
                    <Dialog
                        actions={actions}
                        modal={false}
                        open={this.state.open}
                        onRequestClose={this.handleClose}
                    >
                        {this.state.message}
                    </Dialog>
                </div>
            </MuiThemeProvider>

        )
    }
};


var destination = document.querySelector("#container");

render((
    <Provider store={store}>
        <Router onUpdate={() => window.scrollTo(0, 0)} history={browserHistory}>
            <Route path="/" component={App}>
                <IndexRoute component={SplashHome2Page}/>
                <Route path="projectsupport" component={ProjectPage}/>
                <Route path="companies" component={CompaniesPage}/>
                <Route path="university/:uniId" component={UniversityProfilePage}/>
                <Route path="enterprise" component={EnterprisePage}/>
                <Route path="projects/browse" component={EnterpriseBrowsePage}/>
                <Route path="home2" component={SplashHomePage}/>
                {/*<Route path="students" component={SplashPage}/>*/}
                <Route path="students" component={StudentsPage}/>
                {/*<Route path="educators" component={EducatorsPage}/>*/}
                <Route path="forgot" component={ForgotPage}/>
                <Route path="signin" component={SignInPage}/>
                <Route path="projects/signin" component={ProjectSignInPage}/>
                <Route path="signup" component={SignUpPage}/>
                <Route path="student/signup" component={SignUpPage1}/>
                <Route path="business/signup" component={SignUpPage2}/>
                <Route path="employers/signup" component={ESignUpPage}/>
                <Route path="about" component={AboutPage}/>
                {/*<Route path="helpcenter" component={SplashPage}/>*/}
                <Route path="business" component={EWelcomePage}/>
                <Route path="advertise" component={AdvertisePage}/>
                <Route path="marketing" component={MarketingPage}/>
                <Route path="talent" component={TalentPage}/>
                <Route path="talent/post-a-job" component={PostPage}/>
                <Route path="career" component={CareerPage}/>
                <Route path="press-releases" component={NewsPage}/>
                <Route path="terms" component={TermPage}/>
                <Route path="cookies" component={PolicyPage}/>
                <Route path="privacy" component={PrivacyPage}/>
                <Route path="expert" component={ExpertPage}/>
                <Route path="old-company/:compId(/:ptab)" component={WelcomeCompanyPage}/>
                <Route path="company/:compId(/:ptab)" component={CompanyDetailPage}/>
                <Route path="post-feed(/:jk)" component={ProjectDetailPage}/>
                <Route path="profile/coach/:profileId" component={ProfileCoachPage}/>
                <Route path="profile/:profileId(/:ptab)" component={ProfilePage}/>
                <Route path="talent/contact-us" component={EDemoPage}/>
                <Route path="highered/contact-us" component={EDemo5Page}/>
                <Route path="coupon/contact-us" component={EDemo4Page}/>
                <Route path="companypages/contact-us" component={EDemo2Page}/>
                <Route path="promote/contact-us" component={EDemo3Page}/>
                <Route path="recruite-authentication" component={RecruitePage}/>
                <Route path="post" component={ProjectPostPage}/>
                <Route path="projectterms" component={ProjectTermPage}/>
                <Route path="experiential-challenge/:jk" component={ExperientialChallengeDetailPublic}/>
                <Route path="bridge/:jk" component={InternshipPublic}/>
                <Route path="peer/:jk" component={PeerPublic}/>
            </Route>
			<Redirect from="conversation" to="/signin" />
			<Route component={SplashHome2Page}>
				<Route path="*" component={ErrorPage}/>
			</Route>
        </Router>
    </Provider>),
    destination
);


/** WEBPACK FOOTER **
 ** ./src/client/app/index.jsx
 **/